import axios from 'axios';
import store from '../store';

export const nodeDevDeveloper = 'development';
// export const serverUrl = 'http://127.0.0.1:11223';
// export const serverUrl = 'http://carbis.keenetic.link:11031';
// export const serverUrl = 'http://109.202.22.231:7110';
// export const serverUrl = 'http://saturn.carbis.ru:7747';
export const serverUrl = 'https://reverse.carbis.ru';
// export const serverUrl = process.env.NODE_ENV === nodeDevDeveloper ? serverUrlDev : window.location.origin;

const axiosInstance = axios.create({
  timeout: 60000,
  baseURL: serverUrl
});

async function postNoAuth(resource, params, headers, config){
  try{
    const result = await axiosInstance.post(resource, params, {
      headers: headers,
      ...config });
    return result;
    }
  catch(error){
    store.dispatch('throwTimeoutMessage', {
      text: `${error.message}`,
      message_class: 'error'
    })
  }
}

async function get(resource, headers){
  try {
    const auth_info = localStorage.getItem('auth_data');
    const accessToken = JSON.parse(auth_info).access_token
    const result = await axiosInstance.get(resource, {
      headers: { jwt: `Bearer ${accessToken}`, ...headers }
    });
    return result;
  }
  catch (error) {
    if(error.response.status === 401){
      logout()
    }
    console.log(error)
    store.dispatch('throwTimeoutMessage', {
      text: `${error.message}`,
      message_class: 'error'
    })
  }
}

async function post(resource, params, headers, config){
  try{
    const auth_info = localStorage.getItem('auth_data');
    const accessToken = JSON.parse(auth_info).access_token;
    const result = await axiosInstance.post(resource, params, {
      headers: { jwt: `Bearer ${accessToken}`, ...headers },
      ...config });
    return result;
    }
  catch(error){
    if(error.response.status === 401){
      logout()
    }
    console.log(error)
    store.dispatch('throwTimeoutMessage', {
      text: `${error.message}`,
      message_class: 'error'
    })
  }
}

async function logout(){
  store.dispatch('logout')
}

export const api = {
  get,
  post,
  postNoAuth
};